import { createContext } from "react";

const QrListAllContext = createContext({});

export default QrListAllContext;
